import {$} from '../utils';

// Tab component
const Video = () => {
    $('.playBtn', (e) => {
       e.addEventListener('click', () => {
          const video = e.nextElementSibling;
           e.classList.add('hide');
           video.play();
           video.setAttribute("controls","controls")
       });
    });
};

// Export component
export default Video;